/**
 * Community reviews slider — one slide per view, pagination + arrows, theme editor reload.
 */
(function () {
  const ROOT = '[data-community-clinical-reviews]';

  function destroy(root) {
    if (root._ccrEqualizeResize) {
      window.removeEventListener('resize', root._ccrEqualizeResize);
      root._ccrEqualizeResize = null;
    }
    if (root._ccrSwiper) {
      root._ccrSwiper.destroy(true, true);
      root._ccrSwiper = null;
    }
    const el = root.querySelector('.community-clinical-reviews__swiper');
    if (el) delete el.dataset.swiperInitialized;
    root.querySelectorAll('.community-clinical-reviews__slide-inner').forEach((inner) => {
      inner.style.minHeight = '';
    });
    const mount = root.querySelector('[data-ccr-live-stars]');
    if (mount) mount.innerHTML = '';
  }

  function init(root, attempt) {
    const swiperEl = root.querySelector('.community-clinical-reviews__swiper');
    if (!swiperEl || swiperEl.dataset.swiperInitialized === '1') return;

    const n = typeof attempt === 'number' ? attempt : 0;
    if (typeof window.Swiper === 'undefined') {
      if (n < 80) window.setTimeout(() => init(root, n + 1), 50);
      return;
    }

    const slides = swiperEl.querySelectorAll('.swiper-slide');
    const slideCount = slides.length;
    if (slideCount === 0) return;

    const paginationEl = root.querySelector('.community-clinical-reviews__pagination');
    const prevEl = root.querySelector('.community-clinical-reviews__arrow--prev');
    const nextEl = root.querySelector('.community-clinical-reviews__arrow--next');

    function bulletMarkup(index, className) {
      return `<span class="${className} ccr-pagination__bullet" role="presentation" data-index="${index}"></span>`;
    }

    function syncLiveStars(swiper) {
      const mount = root.querySelector('[data-ccr-live-stars]');
      if (!mount || !swiper || !swiper.slides || swiper.slides.length === 0) return;
      const slide = swiper.slides[swiper.activeIndex];
      if (!slide) return;
      const source = slide.querySelector(
        '.community-clinical-reviews__slide-stars-source .ccr-rating-stars, .community-clinical-reviews__slide-stars-source .rating'
      );
      mount.innerHTML = '';
      if (source) {
        mount.appendChild(source.cloneNode(true));
      }
    }

    function equalizeSlideHeights() {
      const measure = root.querySelectorAll(
        '.community-clinical-reviews__swiper .swiper-slide:not(.swiper-slide-duplicate) > .community-clinical-reviews__slide-inner'
      );
      const applyAll = root.querySelectorAll(
        '.community-clinical-reviews__swiper .community-clinical-reviews__slide-inner'
      );
      if (!measure.length || !applyAll.length) return;
      applyAll.forEach((el) => {
        el.style.minHeight = '';
      });
      let max = 0;
      measure.forEach((el) => {
        const h = el.getBoundingClientRect().height;
        if (h > max) max = h;
      });
      if (max > 0) {
        const px = `${Math.ceil(max)}px`;
        applyAll.forEach((el) => {
          el.style.minHeight = px;
        });
      }
    }

    let resizeTimer;
    function scheduleEqualize(swiper) {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => {
        equalizeSlideHeights();
        if (swiper && typeof swiper.update === 'function') swiper.update();
      }, 80);
    }

    const options = {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 450,
      grabCursor: true,
      watchOverflow: true,
      autoHeight: false,
      on: {
        init(swiper) {
          window.requestAnimationFrame(() => {
            equalizeSlideHeights();
            syncLiveStars(swiper);
            swiper.update();
          });
        },
        slideChange(swiper) {
          syncLiveStars(swiper);
        },
        slideChangeTransitionEnd(swiper) {
          scheduleEqualize(swiper);
        },
        resize(swiper) {
          scheduleEqualize(swiper);
        },
      },
    };

    if (slideCount > 1 && paginationEl) {
      options.pagination = {
        el: paginationEl,
        clickable: true,
        renderBullet: bulletMarkup,
      };
      options.loop = true;
      options.loopedSlides = slideCount;
    }

    if (slideCount > 1 && prevEl && nextEl) {
      options.navigation = {
        prevEl,
        nextEl,
      };
    }

    try {
      root._ccrSwiper = new window.Swiper(swiperEl, options);
      swiperEl.dataset.swiperInitialized = '1';
    } catch (e) {
      const fallback = { ...options, loop: false, rewind: true };
      root._ccrSwiper = new window.Swiper(swiperEl, fallback);
      swiperEl.dataset.swiperInitialized = '1';
    }

    root._ccrEqualizeResize = () => scheduleEqualize(root._ccrSwiper);
    window.addEventListener('resize', root._ccrEqualizeResize);
    window.requestAnimationFrame(() => {
      equalizeSlideHeights();
      if (root._ccrSwiper) {
        syncLiveStars(root._ccrSwiper);
        root._ccrSwiper.update();
      }
    });
  }

  function initFromSection(sectionEl) {
    const root = sectionEl.matches(ROOT) ? sectionEl : sectionEl.querySelector(ROOT);
    if (!root) return;
    destroy(root);
    init(root);
  }

  function boot() {
    document.querySelectorAll(ROOT).forEach((root) => {
      destroy(root);
      init(root);
    });
  }

  document.addEventListener('shopify:section:load', (ev) => {
    const id = ev.detail && ev.detail.sectionId;
    if (!id) return;
    const section = document.querySelector(`#shopify-section-${id}`);
    if (section) initFromSection(section);
  });

  document.addEventListener('shopify:section:unload', (ev) => {
    const id = ev.detail && ev.detail.sectionId;
    if (!id) return;
    const section = document.querySelector(`#shopify-section-${id}`);
    const root = section && section.querySelector(ROOT);
    if (root) destroy(root);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
